import { HeadCell } from 'shell/components/shared/table/types';
import {
  alphanumericRegex,
  nameSurnameMoreCharactersRegex,
  regexOnlyNumber,
} from 'shell/constants/regex';
import { FiltersFormOperator, OperatorClient } from 'system/view-models/operator-list';
import * as yup from 'yup';

export const validationSchemaOperatorsFilter = yup
  .object({
    code: yup
      .string()
      .nullable()
      .notRequired()
      .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri'),
    name: yup
      .string()
      .nullable()
      .notRequired()
      .matches(nameSurnameMoreCharactersRegex, 'Formato non valido'),
    qualification: yup
      .string()
      .nullable()
      .notRequired()
      .matches(nameSurnameMoreCharactersRegex, 'Formato non valido'),
    service: yup
      .string()
      .nullable()
      .notRequired()
      .matches(nameSurnameMoreCharactersRegex, 'Formato non valido'),
    codana: yup.string().nullable().matches(regexOnlyNumber, 'Il campo è un numero'),
  })
  .test('', '', (values) => {
    const castedValues = values as unknown as FiltersFormOperator;

    if (castedValues.codana && castedValues.code) {
      return new yup.ValidationError(
        'Codice e codana sono campi di ricerca alternativi',
        undefined,
        'codAna'
      );
    }

    return true;
  });

export const headCells: HeadCell<OperatorClient, keyof OperatorClient>[] = [
  {
    id: 'code',
    label: 'Codice operatore',
  },
  {
    id: 'codana',
    label: 'CODANA',
  },
  {
    id: 'userExtended',
    label: 'User Estesa',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'fiscalCode',
    label: 'Codice Fiscale',
  },
  {
    id: 'qualification',
    label: 'Qualifica',
  },
  {
    id: 'serviceCode',
    label: 'Codice servizio',
  },
  {
    id: 'service',
    label: 'Servizio',
  },
  {
    id: 'dateDeadline',
    label: 'Scadenza autorizzazioni',
  },
  {
    id: 'action',
    label: '',
  },
];
